import axios from "axios";
import env from "../environment";

// Cliente HTTP das telas PÚBLICAS (link de rastreio) — épico PO1-2887.
//
// Por que não reusar `services/api`: aquela instância tem interceptors que
// anexam `Authorization` e `X-Active-Embarcador-Id` a partir do localStorage.
// A página pública roda na MESMA origem da área logada, então um operador do
// Hub que abrisse o link de rastreio no navegador de trabalho mandava a própria
// sessão junto — e a API respondia em modo AUTENTICADO, escopando por
// embarcador. Resultado: o link do consumidor final devolvia `[]` para quem
// estivesse logado em outro embarcador, e o mesmo link se comportava diferente
// dependendo de quem abria.
//
// Aqui a chamada é sempre anônima, que é exatamente o que o link público é:
// autorizado por conhecer a chave de 44 dígitos, por nada mais.
//
// NÃO adicionar interceptors de autenticação a este arquivo.
const apiPublic = axios.create({
  baseURL: env.API_URL,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
});

export default apiPublic;
